const faqData = [
  {
    id: "one",
    question:
      "Do I need prior skills and knowledge to apply for ACM’s recruitments?",
    answer:
      "Not at all! Everyone is welcome to apply in any domain. All you need is a thirst for knowledge and a drive to grow and develop!",
  },
  {
    id: "two",
    question: "Can second-year students apply for ACM’s recruitments?",
    answer:
      "Yes! Both first and second-year students can apply for ACM’s recruitments.",
  },
  {
    id: "three",
    question: "Where can I attempt the first round?",
    answer: "You need to attempt Round-1 by entering the ACM-RPG.",
  },
  {
    id: "four",
    question: "How do I operate the ACM-RPG?",
    answer:
      "Use the W, A, S, and D keys to move and press ‘Enter’ to interact with objects. It is recommended to use the desktop Chrome version and the default zoom settings.",
  },
  {
    id: "five",
    question: "What are the various domains in which I can apply?",
    answer:
      "You can apply in any of the following domains-<br>Technical - Web Development, App Development, Competitive Coding, Tech General<br>Management - Content Creation, Sponsorship, Outreach<br>Design - UI/UX, Motion Graphics, Graphic Design",
  },
  {
    id: "six",
    question: "How will I know if I cleared Round 1?",
    answer: "You will be notified via email once you’ve cleared Round 1.",
  },
  {
    id: "seven",
    question: "When is the last date to submit answers for Round 1?",
    answer: "Round 1 will be live until 20th February 2022.",
  },
  {
    id: "eight",
    question: "When is the Competitive Coding's recruitment round?",
    answer:
      "The competitive coding department's recruitment will be taken through a competition that will be held on HackerRank from 9-12pm on 23rd February 2022, Wednesday. More details will be shared with you as the time comes.",
  },
];

export default faqData;
